import { Injectable } from '@angular/core';
import { IApplication} from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  public formatPhone(tel: string) {
    if (this.isEmpty(tel)) { return ''; }

    const value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
        return tel;
    }

    let country, city, number;

    switch (value.length) {
        case 10: // +1PPP####### -> C (PPP) ###-####
            country = 1;
            city = value.slice(0, 3);
            number = value.slice(3);
            break;

        case 11: // +CPPP####### -> CCC (PP) ###-####
            country = value[0];
            city = value.slice(1, 4);
            number = value.slice(4);
            break;

        case 12: // +CCCPP####### -> CCC (PP) ###-####
            country = value.slice(0, 3);
            city = value.slice(3, 5);
            number = value.slice(5);
            break;

        default:
            return tel;
    }

    if (country === 1) {
        country = '';
    }

    number = number.slice(0, 3) + '-' + number.slice(3);

    return (country + ' (' + city + ') ' + number).trim();
  }

  public isEmpty(value) : boolean{
    return (value == null || value === '' || value === 'undefined');
  }

  public bidRequirementsMet(application: IApplication, currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean): boolean {
    if (currentBidAmount !== null && currentBidAmount !== undefined && application.contractorBidAmount1 !== currentBidAmount) {
      application.contractorBidAmount1 = currentBidAmount
    }
   if((application.programCycle.bidMustSubmitDoc === true ||application.programCycle.multipleBidsRequired  === true)&&  application.contractorBidAmount1 == undefined ){
    return false;
   }
    if (currentBidSelected !== null && currentBidSelected !== undefined && application.contractorBidAmount1Selected !== currentBidSelected) {
      application.contractorBidAmount1Selected = currentBidSelected
    }
    
    if (currentBidReason !== null && currentBidReason !== undefined && application.contractorBidReason !== currentBidReason) {
      application.contractorBidReason = currentBidReason
    }

    return (
      application.applicationStatus === 700000004 ||
      application.programCycle.bidMustSubmitDoc !== true ||
      ((application.programCycle.multipleBidsRequired === true &&
        ((application.contractorBidAmount1 > 10000 &&
          application.contractorBidAmount2 > 0 &&
          application.contractorBidReason === true) ||
          (application.contractorBidAmount1 > 10000 &&
            application.contractorBidAmount2 > 0 &&
            application.contractorBidReason === false &&
            application.contractorBidAmount1 <=
              application.contractorBidAmount2 &&
            application.contractorBidAmount1Selected === true) ||
          (application.contractorBidAmount2 > 10000 &&
            application.contractorBidAmount1 > 0 &&
            application.contractorBidReason === true) ||
          (application.contractorBidAmount2 > 10000 &&
            application.contractorBidAmount1 > 0 &&
            application.contractorBidReason === false &&
            application.contractorBidAmount2 <=
              application.contractorBidAmount1 &&
            application.contractorBidAmount1Selected === false) ||
          (application.contractorBidAmount1 <= 10000 &&
            application.contractorBidAmount1Selected === true))) ||
        (application.contractorBidAmount2 <= 10000 &&
          application.contractorBidAmount1Selected === false)) ||
      (application.programCycle.bidMustSubmitDoc === true &&
        application.programCycle.multipleBidsRequired !== true &&
        application.contractorBidAmount1 > 0)
    );
  }

}
